// extracted by mini-css-extract-plugin
export default {"reportTableFooter":"ReportTable_reportTableFooter__+Diit"};